var app = angular.module("leonardo");

var WorkOrderTasksList = function ($scope, $attrs, $rootScope, ngDialog, WorkOrderService, PermissionService, AuthDataService,
  NotificationService, FilterService, $timeout) {

  $scope.permissionService = PermissionService;
  $scope.tasks = [];
  $scope.authDataService = AuthDataService;

  $scope.header = 'ALL STATUS';

  $scope.refresh = function () {
    var filters = {};
    filters['disable_pagination'] = true;
    filters['account'] = FilterService.getFilter('account_reports');
    filters['group'] = FilterService.getFilter('group_reports');
    filters['portfolio'] = FilterService.getFilter('portfolio_reports');
    filters['property'] = FilterService.getFilter('property_reports');
    filters['category'] = FilterService.getFilter('category');
    filters['name'] = FilterService.getFilter('name');
    if ($attrs.mode) {
      switch ($attrs.mode) {
        case 'canceled':
          filters['status'] = WorkOrderService.STATUS_CANCELED;
          break;
        case 'completed':
          filters['status'] = WorkOrderService.STATUS_COMPLETED;
          break;
        case 'scheduled':
          filters['status'] = WorkOrderService.STATUS_SCHEDULED;
          break;
        default:
          filters['status'] = WorkOrderService.STATUS_CALL;
          break;
      }
    } else {
      if (FilterService.getFilter('status')) {
        filters['status'] = FilterService.getFilter('status');
      } else {
        var status = [WorkOrderService.STATUS_CALL, WorkOrderService.STATUS_SCHEDULED, WorkOrderService.STATUS_IN_PROGRESS];
        filters['status'] = status.join(',');
      }
    }

    WorkOrderService.getlist(filters, true).then(function (list) {
      $scope.tasks = list.results ? list.results : list;
    });
    $scope.getHeader();
  };

  $scope.getHeader = function () {
    switch (FilterService.getFilter('status')) {
      case WorkOrderService.STATUS_CALL:
        $scope.header = 'ON CALL';
        break;
      case WorkOrderService.STATUS_SCHEDULED:
        $scope.header = 'SCHEDULED';
        break;
      case WorkOrderService.STATUS_IN_PROGRESS:
        $scope.header = 'IN PROGRESS';
        break;
      case WorkOrderService.STATUS_CANCELED:
        $scope.header = 'CANCELED';
        break;
      default:
        $scope.header = 'ALL STATUS';
        break;
    }
  };

  $scope.$on('work-order:updated', $scope.refresh);
  $scope.$on('work-order:created', $scope.refresh);
  $scope.$on('work-order:deleted', $scope.refresh);

  $scope.$on('filter-selection:updated', function () {
    $scope.refresh();
  });

  $scope.$on('task-resolve-dialog:success', function () {
    $scope.refresh();
  });

  $scope.$on('task-notes:updated', function () {
    $scope.refresh();
  });

  $scope.$on('task-cannot-do-dialog:success', function () {
    $scope.refresh();
  });

  $scope.$on('task-work-order-status:updated', function () {
    $scope.refresh();
  });

  $scope.$on('task-assign-user:updated', function () {
    $scope.refresh();
  });

  $scope.$on('task-priority-dialog:success', function () {
    $scope.refresh();
  });

  $timeout(function () {
    $scope.refresh();
  }, 0);
};

app.controller('WorkOrderTasksList', ['$scope', '$attrs', '$rootScope', 'ngDialog', 'WorkOrderService', 'PermissionService',
  'AuthDataService', 'NotificationService', 'FilterService', '$timeout', WorkOrderTasksList
]);
